import React, {useState} from "react";
import {closePopup, getElementValue, openPopup} from "../../utils/CommonUtils";
import closeV2 from "../../static/image/v2/popup/closeV2.png";
import {inputMaxLength, setValue} from "../../static/js/Common2";
import {getFreeImageApi} from "../../api/imageApi";
import ImageEditor from "../imageEdit/ImageEditor";

const MenuImageSearchPopup2 = ({setFileList, setModifyFileList}) => {
  const [list, setLIst] = useState([]);
  const [selectedId, setSelectedId] = useState(null);
  const [selectedImageUrl, setSelectedImageUrl] = useState(null);
  const [selectedType, setSelectedType] = useState(1);

  const handleSearchEvent = async (type) => {
    const getKeyword = getElementValue(`searchInput${type}`);

    if (getKeyword.length >= 2) {
      const searchData1 = {
        page: 1,
        count: 50,
        searchKeyword: getKeyword,
        searchType: 2,
        type: 9,
      };
      const searchData2 = {
        page: 1,
        count: 50,
        searchKeyword: getKeyword,
        searchType: 1,
        type: 9,
      };

      try {
        const [response1, response2] = await Promise.all([
          getFreeImageApi(searchData1),
          getFreeImageApi(searchData2),
        ]);

        const combinedData = [
          ...(response1?.data || []),
          ...(response2?.data || []),
        ];

        setLIst(combinedData);
      } catch (error) {
        console.error("검색 중 오류 발생:", error);
      }
    } else {
      alert("검색어를 2자 이상 입력해주세요");
    }
  }

  const handleSelect = (id) => {
    setSelectedId(id); // 클릭한 id를 상태로 저장
  };

  const handleSelectedEvent = (type) => {
    const imageData = list.find((value) => value.id === selectedId);
    setSelectedImageUrl(imageData?.imageUrl);
    openPopup(`menuImageSearchPopup3`);
  }

  const handleImageSelectEvent = (type) => {
    const menuImgPreview1 = document.querySelector(`#menuImgPreview${type} .menuImg`);
    const imageData = list.find((value) => value.id === selectedId);
    menuImgPreview1.setAttribute("src", imageData?.imageUrl);
    menuImgPreview1.setAttribute("data-id", selectedId);
    document.querySelector(`#menuImgPreview${type} .imgBtn`).classList.add("hide");
    document.querySelector(`#menuImgPreview${type} .imageSearchBtn`).classList.add("hide");
    document.querySelector(`#menuImgPreview${type} .menuImgPreview`).classList.remove("hide");
    setSelectedType(type);
    handleSelectedEvent(type);
  }

  const handleClose = (type) => {
    setSelectedId(null);
    setLIst([]);
    setValue(`searchInput${type}`, "");
    closePopup(`menuImageSearchPopup${type}`);
  }

  return (
    <>
      <div className="popupV2 hide" id="menuImageSearchPopup1">
        <div className="popupContainer width578">
          <div className="popupTitle">
            <h2>메뉴 이미지 검색</h2>
            <button className="closeBtn" onClick={() => handleClose(1)}>
              <img src={closeV2} alt="취소" />
            </button>
          </div>
          <div className="popupContent">
            <div className='popupFlexBox popupFlexBox1'>
              <input
                id='searchInput1' className="searchInput" name='searchInput' type='text'
                maxLength={30} onInput={(e) => inputMaxLength(e)}
                placeholder="메뉴명으로 검색해주세요"
              />
              <button
                type="text"
                className="imageSearchBtn bg-blue fc-white ml-5"
                onClick={() => handleSearchEvent(1)}
              >
                이미지 검색
              </button>
            </div>
            <div className="popupFlexBox searchTextBox">
              <span>※사용 전 꼭 확인해주세요!</span><br/>
              제공드리는 이미지는 저작권법에 따라 띵동 앱에서만 사용할 수 있어요 저작권 분쟁 발생 시 띵동에서는 책임지지 않아요
            </div>
            <div className="searchImageBox">
              {list.map((value, index) => {
                return (
                  <div
                    data-id={value.id}
                    className={selectedId === value.id ? "active" : ""}
                    key={index}
                    onClick={() => handleSelect(value.id)}
                  >
                    <img src={value.imageUrl} alt={value.name} />
                    <p className="searchImageName">{value.name}</p>
                  </div>
                )
              })}
              {list.length === 0 &&
                <p className="mt-5 fs-18 fw-7">검색결과가 없습니다</p>
              }
            </div>

          </div>
          <div className='popupBtn'>
            <button type='button' className='closeBtn stopCloseBtn' onClick={() => handleClose(1)}>취소</button>
            <button type='button' id="shopInfo1Btn" className='shopInfo1Btn blueBtn' onClick={() => handleSelectedEvent(1)}>확인</button>
          </div>
        </div>
      </div>

      <div className="popupV2 hide" id="menuImageSearchPopup2">
        <div className="popupContainer width578">
          <div className="popupTitle">
            <h2>메뉴 이미지 검색</h2>
            <button className="closeBtn" onClick={() => handleClose(2)}>
              <img src={closeV2} alt="취소" />
            </button>
          </div>
          <div className="popupContent">
            <div className='popupFlexBox popupFlexBox1'>
              <input
                id='searchInput2' className="searchInput" name='searchInput' type='text'
                maxLength={30} onInput={(e) => inputMaxLength(e)}
                placeholder="메뉴명으로 검색해주세요"
              />
              <button
                type="text"
                className="imageSearchBtn bg-blue fc-white ml-5"
                onClick={() => handleSearchEvent(2)}
              >
                이미지 검색
              </button>
            </div>
            <div className="popupFlexBox searchTextBox">
              <span>※사용 전 꼭 확인해주세요!</span><br/>
              제공드리는 이미지는 저작권법에 따라 띵동 앱에서만 사용할 수 있어요 저작권 분쟁 발생 시 띵동에서는 책임지지 않아요
            </div>
            <div className="searchImageBox">
              {list.map((value, index) => {
                return (
                  <div
                    data-id={value.id}
                    className={selectedId === value.id ? "active" : ""}
                    key={index}
                    onClick={() => handleSelect(value.id)}
                  >
                    <img src={value.imageUrl} alt={value.name} />
                    <p className="searchImageName">{value.name}</p>
                  </div>
                )
              })}
              {list.length === 0 &&
                <p className="mt-5 fs-18 fw-7">검색결과가 없습니다</p>
              }
            </div>

          </div>
          <div className='popupBtn'>
            <button type='button' className='closeBtn stopCloseBtn' onClick={() => handleClose(2)}>취소</button>
            <button type='button' id="shopInfo1Btn" className='shopInfo1Btn blueBtn' onClick={() => handleImageSelectEvent(2)}>확인</button>
          </div>
        </div>
      </div>

      <div className="popupV2 hide" id="menuImageSearchPopup3">
        <div className="popupContainer width750">
          <div className="popupTitle">
            <h2>메뉴 편집</h2>
            <button className="closeBtn" onClick={() => closePopup(`menuImageSearchPopup3`)}>
              <img src={closeV2} alt="취소" />
            </button>
          </div>
          <ImageEditor
            imageUrl={selectedImageUrl}
            type={selectedType}
            setFileList={setFileList}
            setModifyFileList={setModifyFileList}
            onClose={() => { setLIst([]); setValue(`searchInput${selectedType}`, ""); }} />
        </div>
      </div>

      <div className="popupV2 hide" id="menuImageSearchPopup4">
        <div className="popupContainer width450">
          <div className="popupTitle">
            <h2>미리보기</h2>
            <button className="closeBtn" onClick={() => closePopup(`menuImageSearchPopup4`)}>
              <img src={closeV2} alt="취소" />
            </button>
          </div>
          <div className="popupContent">
            <div className="menuSearchPreviewBox">
              <div className="menuSearchPreview menuSearchPreview1">
                <img src="" alt="" />
              </div>
              <div className="menuSearchPreview menuSearchPreview2">
                <img src="" alt="" />
              </div>
            </div>
          </div>
          <div className='popupBtn'>
            <button type='button' className='closeBtn stopCloseBtn oneBtn' onClick={() =>  closePopup(`menuImageSearchPopup4`)}>닫기</button>
          </div>
        </div>
      </div>
    </>
  )
}

export default MenuImageSearchPopup2;